import { render, staticRenderFns } from "./RecordingDetailsTabCaravanists.vue?vue&type=template&id=0dc803ea"
import script from "./RecordingDetailsTabCaravanists.vue?vue&type=script&lang=js"
export * from "./RecordingDetailsTabCaravanists.vue?vue&type=script&lang=js"
import style0 from "./RecordingDetailsTabCaravanists.vue?vue&type=style&index=0&id=0dc803ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports